import React from 'react';
import InstallationSubZonesBody from './InstallationSubZonesBody';
import { ZonesProvider } from '../../../shared/installations/zones/provider/ZonesContext';

const InstallationSubZones = () => {
  return (
    <ZonesProvider>
      <div className="col-12 after-summary">
        <InstallationSubZonesBody />
      </div>
    </ZonesProvider>
  );
};

export default InstallationSubZones;
